export default __webpack_public_path__ + "static/out_sourcing-7309145ee8cdd048953353d1a284478a.jpg";